import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m6.279 3.73.003.001 21.155 7.323h.001c1.847.634 1.76 3.233-.066 3.8l-.002.001-9.563 2.95-.005.002-2.946 9.562-.001.003c-.568 1.826-3.167 1.913-3.8.066l-.001-.002L3.732 6.281 3.73 6.28A2 2 0 0 1 6.279 3.73M4.675 5.95l.945-.327 7.324 21.159v-.003l2.948-9.565a1.94 1.94 0 0 1 1.342-1.325l9.544-2.944.004-.002L5.618 5.619z"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconNavigationArrow = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconNavigationArrow);
export default Memo;
